import React, { useState } from "react";
import { Form, Button, Container } from "react-bootstrap";
import { FaCloudUploadAlt } from "react-icons/fa";
import langData from "../../locales/langData.json";
import "../../assets/css/contactform.css";

function CareerForm({ onClose, language }) {
  const t = langData[language]?.careerForm || langData.en.careerForm;
  const v = langData[language]?.validation || langData.en.validation;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    resume: null,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors((p) => ({ ...p, [name]: "" }));
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, resume: e.target.files[0] });
    setErrors((p) => ({ ...p, resume: "" }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = v.required;
    if (!formData.phone.trim()) newErrors.phone = v.required;

    if (!formData.email.trim()) {
      newErrors.email = v.required;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = v.email;
    }

    if (!formData.resume) newErrors.resume = v.resume;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const file = formData.resume;
    const reader = new FileReader();

    reader.onloadend = async () => {
      const base64File = reader.result.split(",")[1];

      const payload = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        fileName: file.name,
        fileType: file.type,
        resume: base64File,
      };

      try {
        await fetch(
          "https://script.google.com/macros/s/AKfycbw25NzgdA1V-EGKeCfko8zuI7opVnoTTGXomYiMHUyHskwd4b6Kziz5WfDDo1CYQhNc7g/exec",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          }
        );

        alert(t.success);
        onClose();
      } catch (error) {
        alert(t.error);
      }
    };

    reader.readAsDataURL(file);
  };

  return (
    <Container className="career-form py-5">
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.6)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "1.5rem",
          zIndex: 2147483646,
        }}
        onClick={onClose}
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 12,
            width: "100%",
            maxWidth: 520,
            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
            padding: "24px",
            position: "relative",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={onClose}
            aria-label="Close"
            style={{
              position: "absolute",
              top: 10,
              right: language === "ar" ? "auto" : 12,
              left: language === "ar" ? 12 : "auto",
              border: "none",
              background: "transparent",
              fontSize: 20,
              cursor: "pointer",
            }}
          >
            ✕
          </button>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-2">
              <Form.Label>{t.fullName}</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder={t.placeholderName}
                onChange={handleChange}
              />
              {errors.name && <small className="text-danger">{errors.name}</small>}
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>{t.email}</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder={t.placeholderEmail}
                onChange={handleChange}
              />
              {errors.email && <small className="text-danger">{errors.email}</small>}
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>{t.phone}</Form.Label>
              <Form.Control
                type="tel"
                name="phone"
                placeholder={t.placeholderPhone}
                onChange={handleChange}
              />
              {errors.phone && <small className="text-danger">{errors.phone}</small>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{t.upload}</Form.Label>
              <div className="upload-box">
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                  className="file-input"
                  id="resumeUpload"
                />
                <label htmlFor="resumeUpload" className="upload-label">
                  <FaCloudUploadAlt size={40} color="#683FEA" />
                  <p>
                    <strong>{t.dragDrop}</strong> {t.orClick}
                  </p>
                  <small>{t.supports}</small>

                  {formData.resume && (
                    <div className="mt-2 text-success">
                      {formData.resume.name}
                    </div>
                  )}
                </label>
              </div>
              {errors.resume && (
                <small className="text-danger d-block mt-1">
                  {errors.resume}
                </small>
              )}
            </Form.Group>

            <Button type="submit" className="w-100 form-btn">
              {t.submit}
            </Button>
          </Form>
        </div>
      </div>
    </Container>
  );
}

export default CareerForm;
